function Footer() {
  return (

  <footer>
    &copy; Jessica Laporte &amp; Marko Vukmirovic - For Educational Purpose 2022
  </footer>

  )
}
export default Footer